module.exports = __webpack_public_path__ + "img/earth.b7beaa06.svg";